import { Injectable } from '@angular/core';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { SaveCreditsFormActionHandlerService } from './save-credits.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { SignaturesManageService } from '../../../management/signatures/manage/manage.service';
import { AttachmentsService } from '../../../project/services/attachments.service';
import {NavService} from '../../../fastlane-common/services/nav.service';

@Injectable({
  providedIn: 'root'
})
export class ResendInitialCertLetterService extends SaveCreditsFormActionHandlerService {
  constructor(
    public attachmentService: AttachmentsService,
    dataService: FormDataService,
    formShareService: FormShareService,
    statusService: FormStatusService,
    swalService: SwalService,
    userContextService: UserContextService,
    private esignService: SignaturesManageService,
    emailService: EmailService,
    pubSubService: PublishSubscribeService,
    public navService: NavService
  ) {
    super(
      attachmentService,
      dataService,
      formShareService,
      statusService,
      swalService,
      userContextService,
      emailService,
      pubSubService,
      navService
    );
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      super
        .exec()
        .then(() => {
          that.esignService
            .cancelAgreement(that.formShareService.form.projectAgreementId)
            .subscribe(() => {
              that.swalService.dismiss();
              that.swalService.load('Resending the Letter....');
              that.esignService
                .resendAgreement(that.formShareService.form.projectAgreementId)
                .subscribe(() => {
                  that.swalService.success({
                    title:
                      'Initial Certification Letter has been Resent for Signature successfully!!'
                  });
                });
            });
        })
        .catch(() => {});
    });
  }
}
